/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Interval/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Interval({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Interval"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData = 'From'
let scheduleNoteStartValueData = fromData.useDataFormat({ viewPath,
context: 'schedule_note',
path: 'start',
format: fromFormat.dateISOToTime,
})
let constantData1 = 'to'
let scheduleNoteEndValueData = fromData.useDataFormat({ viewPath,
context: 'schedule_note',
path: 'end',
format: fromFormat.dateISOToTime,
})
let aggregateData = fromAggregate.join(constantData, scheduleNoteStartValueData, constantData1, scheduleNoteEndValueData)
  return (<React.Fragment
>
<div
  data-testid="Interval.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-JQQPF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'From'"
 data="schedule_note.start"
 format="/Data/format.js dateISOToTime"
 data="'to'"
 data="schedule_note.end"
 format="/Data/format.js dateISOToTime"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}